import React from "react";
import {DayItem} from "@/utils/DateUtils";
import TimesheetTable from "@widgets/reports/timesheet/chart/TimesheetTable";
import TimesheetStats from "@widgets/reports/timesheet/chart/TimesheetStats";
import {DateRange} from "react-day-picker";
import {EmployeeInReport} from "@/data/entities/employee";
import {SetStateFn} from "@/utils/SetStateUtils";

type Props = {
    dateRange: DateRange,
    daysBetween: DayItem[]
    data: EmployeeInReport[],
    setData: SetStateFn<EmployeeInReport[]>,
};

const TimesheetOverview = ({dateRange, data, setData, daysBetween}: Props) => {

    return (
        <div className={"w-full flex flex-col gap-8 md:gap-12"}>
            <TimesheetStats
                data={data}
                dateRange={dateRange}
            />

            {
                data &&
                <TimesheetTable
                    daysBetween={daysBetween}
                    data={data}
                    setData={setData}
                />
            }
        </div>
    );
};

export default TimesheetOverview;